import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const Unauthorised = ({
  ...props
}) => (
  <Redirect to={{ pathname: '/', state: { from: props.location } }} />
);

Unauthorised.propTypes = {
  location: PropTypes.shape().isRequired,
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(Unauthorised);



// WEBPACK FOOTER //
// ./src/components/RedirectHome/RedirectHome.jsx